module.exports = "/packs/thumbnail_mokumoku-9ca7896c3837fa7126ec353df06f5dc5.png";